var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 44,
    viewBox: "0 0 158 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dnmfsbvcsa",
    d: "M0 0.097L43.207 0.097 43.207 43.819 0 43.819z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "01112rqlic",
    d: "M0.023 0.052L14.471 0.052 14.471 14.871 0.023 14.871z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EC6A5A",
    d: "M32.188 15.908L13.412 21.459 13.412 16.28 32.188 10.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007270",
    d: "M32.188 26.638L13.412 32.188 13.412 27.01 32.188 21.459z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "qk64z8qnvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dnmfsbvcsa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00AECA",
    d: "M21.604 4.568c-9.476 0-17.185 7.801-17.185 17.39 0 9.588 7.709 17.389 17.185 17.389 9.476 0 17.184-7.8 17.184-17.39 0-9.588-7.708-17.389-17.184-17.389m0 39.25C9.69 43.819 0 34.013 0 21.959S9.691.097 21.604.097c11.912 0 21.603 9.807 21.603 21.86 0 12.055-9.691 21.862-21.603 21.862",
    mask: "url(#qk64z8qnvb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M57.448 23.712h-2.35v3.38h2.326c1.162 0 2.202-.4 2.202-1.778 0-1.326-1.089-1.602-2.178-1.602m-.544-6.834h-1.806v2.879h1.781c1.014 0 1.856-.3 1.856-1.477 0-1.176-.866-1.402-1.83-1.402m5.516 12.767c-1.88 1.627-3.612 1.602-5.987 1.602H50.62V12.723h5.64c2.202 0 4.28.025 5.863 1.802.767.851 1.088 1.903 1.088 3.054 0 1.577-.766 2.954-2.127 3.73 2.003.701 3.018 2.203 3.018 4.306 0 1.477-.544 3.054-1.682 4.03M73.826 31.247v-7.56c0-1.502-.42-2.904-2.202-2.904-1.78 0-2.3 1.177-2.3 2.754v7.71h-4.108V12.723h4.108v5.908h.049c.717-1.302 2.152-1.753 3.537-1.753 1.337 0 2.845.476 3.736 1.527 1.311 1.527 1.287 3.18 1.287 5.082v7.76h-4.107zM86.467 20.758c-2.003 0-3.389 1.603-3.389 3.58 0 1.927 1.485 3.505 3.414 3.505 2.004 0 3.44-1.552 3.44-3.555 0-2.028-1.46-3.53-3.465-3.53zm3.464 10.489v-1.502h-.05c-.742 1.427-2.523 1.978-4.007 1.978-4.23 0-6.902-3.305-6.902-7.435 0-4.056 2.77-7.41 6.902-7.41 1.51 0 3.191.576 4.008 1.953h.05v-1.477h4.106v13.893H89.93zM99.877 23.612v7.635H95.77V17.354h3.86v1.477h.05c.717-1.427 1.854-1.953 3.438-1.953v4.18c-1.806.05-3.24.401-3.24 2.554M110.812 20.758c-2.004 0-3.389 1.603-3.389 3.58 0 1.927 1.484 3.505 3.413 3.505 2.004 0 3.44-1.552 3.44-3.555 0-2.028-1.46-3.53-3.464-3.53zm3.464 10.489v-1.502h-.05c-.742 1.427-2.524 1.978-4.008 1.978-4.23 0-6.902-3.305-6.902-7.435 0-4.056 2.77-7.41 6.902-7.41 1.51 0 3.192.576 4.008 1.953h.05v-1.477h4.106v13.893h-4.106zM125.804 20.508L125.804 31.247 121.697 31.247 121.697 20.508 119.669 20.508 119.669 17.354 121.697 17.354 121.697 12.723 125.804 12.723 125.804 17.354 127.783 17.354 127.783 20.508z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AECA",
    d: "M135.948 16.878h-1.733v4.406h1.906c1.533 0 2.919-.35 2.919-2.228 0-1.928-1.56-2.178-3.092-2.178m5.64 6.96c-1.583 1.401-3.29 1.602-5.344 1.602h-2.029v5.807h-4.477V12.723h5.987c1.88 0 4.13.075 5.64 1.351 1.434 1.227 2.153 3.004 2.153 4.907 0 1.702-.644 3.705-1.93 4.857"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(143.42 16.826)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uzq6ys4nid",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#01112rqlic"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00AECA",
    d: "M7.247 3.556c-1.484 0-2.795.876-3.117 2.379h6.234c-.321-1.503-1.633-2.379-3.117-2.379m7.125 5.182H4.08c.248 1.652 1.609 2.629 3.216 2.629 1.114 0 1.831-.451 2.499-1.302H14c-1.188 2.779-3.612 4.806-6.705 4.806-4.007 0-7.273-3.304-7.273-7.36 0-4.03 3.167-7.46 7.2-7.46 4.205 0 7.248 3.405 7.248 7.586 0 .375-.025.726-.1 1.101",
    mask: "url(#uzq6ys4nid)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpLogo);
export default __webpack_public_path__ + "static/media/bp-logo.71d4ea559ff28800b70609dcbdd19cfd.svg";
export { ForwardRef as ReactComponent };